import React from 'react';

import { useTheme } from 'styled-components';

import Chip from 'components/Chip/Chip';

import { AcknowledgementState } from 'utils/api/modules/entities/entities.types';

interface AcknowledgementStateChipProps {
  state: AcknowledgementState;
}

const AcknowledgementStateChip: React.FunctionComponent<AcknowledgementStateChipProps> = ({ state }) => {
  const theme = useTheme();

  const config = ((): { label: string; background: string; foreground: string } => {
    switch (state) {
      case AcknowledgementState.Acknowledged:
        return {
          label: 'Acknowledged',
          background: theme.tint.success.medium,
          foreground: theme.palette.success.dark,
        };
      case AcknowledgementState.Pending:
        return {
          label: 'Pending',
          background: theme.tint.warning.medium,
          foreground: theme.toast.warning.text,
        };
      case AcknowledgementState.Cancelled:
      default:
        return {
          label: 'Cancelled',
          background: theme.palette.grey[200],
          foreground: theme.palette.text.secondary,
        };
    }
  })();

  return (
    <Chip size="small" label={config.label} colors={{ background: config.background, foreground: config.foreground }} />
  );
};

export default AcknowledgementStateChip;
